module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chaptertitle"
  }, [_c('a', {
    attrs: {
      "id": "p3"
    }
  }), _vm._v(" Lisa Peters's Rally Circuit Honey Nut Granola")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("Here is a breakfast treat that you can pack in your saddlebags and take on the road for a tasty breakfast far from home. This recipe comes from Lisa Marie Kateri Peters, a Harley fan and regular on the rally circuit who hails from New Hampshire. Lisa says, \"I am a licensed massage therapist and have a thriving office practice, as well as a reasonably decent following of touch junkies out on the motorcycle rally circuit. I love to take my massage chair out on the road and hit as many events as I can during the rally season. I love being out in the fresh air, working on people who are regular massage receivers and being able to introduce massage to people who are new to the idea. And I've yet to meet someone who couldn't use a great massage! Plus, I get to be outside enjoying the beautiful rumble of all those throaty Harley-Davidsons.\" Take it from me, she knows how to cook and heal road-weary backs. Try this tasty breakfast, then ride off to a rally for a great massage.")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('table', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("1")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("cup corn, sunflower, or canola oil")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("1")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("cup honey")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("5")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("cups old-fashioned rolled oats")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("1")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("cup unprocessed sesame seeds")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("1")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("cup wheat germ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("1")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("cup unsweetened shredded coconut")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("1")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("cup nonfat instant milk")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("1")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("cup soy granules (optional)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("1")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("cup sliced almonds")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("1")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("cup walnut pieces")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("1")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("cup shelled roasted pumpkin seeds (available at the health food store)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("1")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("cup golden raisins")])])])]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("Preheat the oven to 275°F.")]), _vm._v(" "), _c('li', [_vm._v("In a large mixing bowl, mix together the corn oil and honey. Add the rest of the ingredients, except the raisins, and mix until everything's coated with the honey mixture. Spread the mixture out over 2 ungreased baking sheets and bake for 30 minutes at 275°F, then reduce the oven temperature to 250°F and bake till light brown, stirring the mixture every 10 to 15 minutes so it browns all over.")]), _vm._v(" "), _c('li', [_vm._v("Remove from the oven, let cool a bit, and stir in the raisins. Let cool completely, then store in an airtight container to keep it from getting stale.")])]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("MAKES")]), _vm._v(" 10 "), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("TO")]), _vm._v(" 12 "), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("CUPS")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26f13440","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c001.vue
// module id = 81
// module chunks = 0